export const validateCode = (code: string, regex: RegExp): boolean => {
  try {
    const result = regex.test(code);
    return result;
  } catch (error) {
    console.log('Error: code could not be validated');
    return false;
  }
};